module.exports = "<svg viewBox=\"0 0 23.1 10.1\"><circle cx=\"5.1\" cy=\"5.1\" r=\"5.1\" fill=\"#231F20\"></circle><path fill=\"#231F20\" d=\"M18 1.5c1.9 0 3.5 1.6 3.5 3.5S19.9 8.6 18 8.6 14.5 7 14.5 5.1s1.6-3.6 3.5-3.6M18 0c-2.8 0-5.1 2.3-5.1 5.1s2.3 5.1 5.1 5.1 5.1-2.3 5.1-5.1S20.8 0 18 0z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/flickr.svg
// module id = 300
// module chunks = 1